import { useState } from 'react';
import { useAuth, useLocale } from '../../context';
import { api, toUserFacingError } from '../../api';
import { findSupportTemplate, useSupportConfig } from '../../hooks/useSupportConfig';
import SupportDynamicForm from '../account/SupportDynamicForm';

export default function MobileNewRequestForm({ templateId, onDone, onCancel }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const locale = _locale.locale;
  const { token } = useAuth();
  const { config } = useSupportConfig();
  const match = findSupportTemplate(config, templateId);
  const template = match?.template;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (body) => {
    if (!token) return;
    setLoading(true);
    setError('');
    try {
      await api.createSupportTicket(token, { ...body, locale });
      onDone?.();
    } catch (err) {
      setError(toUserFacingError(err.message, tr('account.requests.error')));
    } finally {
      setLoading(false);
    }
  };

  if (!template) {
    return (
      <div className="mobile-request-form">
        <p>{tr('account.requests.notFound')}</p>
        <button type="button" className="mobile-request-form__cancel" onClick={onCancel}>{tr('common.back')}</button>
      </div>
    );
  }

  return (
    <SupportDynamicForm
      template={template}
      typeKey={templateId}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      loading={loading}
      error={error}
      submitLabel={tr('account.requests.submit')}
      cancelLabel={tr('common.cancel')}
    />
  );
}
